import { FC } from 'react';
import { Modal as QcsModal } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { QcsModalBox } from './basic/QcsModalBox';
import { SectionHeader } from './SectionHeader';
import { QcsBox } from './basic/QcsBox';
import { QcsLoadingButton } from './basic/QcsLoadingButton';
import { ShowError } from '../ShowError';
import { Resource } from '@api/resources';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  title?: string;
  message?: string;
  confirmButtonKey?: string;
  cancelButtonKey?: string;
  resource?: Resource | Resource[];
}

export const ConfirmDeleteModal: FC<Props> = ({
  open,
  onConfirm,
  onCancel,
  loading = false,
  title,
  message,
  confirmButtonKey,
  cancelButtonKey,
  resource,
}) => {
  const { t } = useTranslation();

  return (
    <QcsModal open={open} onClose={onCancel}>
      <QcsModalBox>
        <SectionHeader title={title ? t(title) : t('common.confirmDelete.title')} />
        {message && <QcsBox sx={{ mb: 3 }}>{t(message)}</QcsBox>}
        {resource && <ShowError resource={resource} />}
        <QcsBox sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <QcsLoadingButton loading={loading} variant="contained" color="error" onClick={onConfirm}>
            {t(confirmButtonKey ?? 'common.confirmDelete.confirm')}
          </QcsLoadingButton>
          <QcsLoadingButton loading={loading} variant="outlined" onClick={onCancel}>
            {t(cancelButtonKey ?? 'common.confirmDelete.cancel')}
          </QcsLoadingButton>
        </QcsBox>
      </QcsModalBox>
    </QcsModal>
  );
};
